import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
      <g id="B" transform="translate(40.000, 29.000) scale(0.75)" /*transform="translate(11.000000, 5.000000)"*/>
        <path
          d="M0 45.26L0 9.47L15.87 9.47Q20.65 9.47 23.14 10.44Q25.63 11.40 27.12 13.84Q28.61 16.28 28.61 19.24Q28.61 23.05 26.15 25.66Q23.68 28.27 18.53 28.98Q20.41 29.88 21.39 30.76Q23.46 32.67 25.32 35.52L31.54 45.26L25.59 45.26L20.85 37.82Q18.77 34.59 17.43 32.89Q16.09 31.18 15.03 30.49Q13.96 29.81 12.87 29.54Q12.06 29.37 10.23 29.37L4.74 29.37L4.74 45.26L0 45.26M4.74 25.27L14.92 25.27Q18.16 25.27 20.00 24.60Q21.83 23.93 22.78 22.45Q23.73 20.97 23.73 19.24Q23.73 16.70 21.89 15.06Q20.04 13.43 16.06 13.43L4.74 13.43L4.74 25.27Z"
          // d="M45.691667,45.15 C48.591667,46.1 50.691667,48.95 50.691667,52.2 C50.691667,57.95 46.691667,61 40.291667,61 L28.541667,61 L28.541667,30.3 L39.291667,30.3 C45.691667,30.3 49.691667,33.15 49.691667,38.65 C49.691667,41.95 47.941667,44.35 45.691667,45.15 Z M33.591667,43.2 L39.241667,43.2 C42.791667,43.2 44.691667,41.85 44.691667,38.95 C44.691667,36.05 42.791667,34.8 39.241667,34.8 L33.591667,34.8 L33.591667,43.2 Z M33.591667,47.5 L33.591667,56.5 L40.191667,56.5 C43.691667,56.5 45.591667,54.75 45.591667,52 C45.591667,49.2 43.691667,47.5 40.191667,47.5 L33.591667,47.5 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.2"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
